<template>
  <VehicleBaseLayout>
    <FilterResultApp />
  </VehicleBaseLayout>
</template>

<script>
import FilterResultApp from '@/views/vehicles/components/FilterResultApp.vue';
import {mapActions, mapMutations} from "vuex";
import VehicleBaseLayout from "@/layouts/VehicleBaseLayout.vue";

export default {
  name: "VehiclesView",
  data (){
    return {
      name: undefined
    }
  },
  components: {
    VehicleBaseLayout,
    FilterResultApp
  },
  methods: {
    ...mapMutations("global", ["setCurrentMainMenu"]),
    ...mapActions("filterForm", ["search", "searchFilters", 'getAdTypes']),
  },
  async mounted() {
    this.setCurrentMainMenu({
      section: "vehicles",
      breadcrumb: "Veículos",
      breadcrumbMobile: "Veículos",
      filter: true,
      order: true,
    });
    await Promise.all([
      this.searchFilters(),
      this.search(),
      this.getAdTypes(),
    ])
  }
};
</script>
